import React, { useState, useEffect } from "react";
import DesktopNavBarComponent from "./DesktopNavBarComponent.js";
import MobileNavBarComponent from "./MobileNavBarComponent.js";

const NavBarComponentTwo = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile ? <MobileNavBarComponent /> : <DesktopNavBarComponent />;
};

export default NavBarComponentTwo;
